<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="ImpersonationForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="ImpersonationForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddImpersonationModal(AddImpersonationModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <!--begin::Permission list-->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">

                <th class="min-w-150px"> [{{utilityService.getResourceValue("ParticipantType")}}]{{utilityService.getResourceValue("Source")}}</th>
                <th class="min-w-150px"> [{{utilityService.getResourceValue("ParticipantType")}}]{{utilityService.getResourceValue("Destination")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("ExpiresAt")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Active")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let Impersonation of ImpersonationPagingResult">

                <td>
                  <span *ngIf="language=='ar'" class="text-dark">
                    [{{Impersonation.sourceParticipantDTO.participantTypeItemName.arabic}}] {{Impersonation.sourceParticipantDTO.participantName.arabic}}
                  </span>
                  <span *ngIf="language=='en'" class="text-dark">
                    [{{Impersonation.sourceParticipantDTO.participantTypeItemName.english}}] {{Impersonation.sourceParticipantDTO.participantName.english}}
                  </span>

                </td>
                <td *ngIf="language=='ar'">  [{{Impersonation.destinationParticipantDTO.participantTypeItemName.arabic}}] {{Impersonation.destinationParticipantDTO.participantName.arabic}}</td>
                <td *ngIf="language=='en'">[{{Impersonation.destinationParticipantDTO.participantTypeItemName.english}}] {{Impersonation.destinationParticipantDTO.participantName.english}}</td>

                <td>{{Impersonation.expiresAt}}</td>
                <td>{{Impersonation.isActive}}</td>

                <td>

                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a class="drop-item px-3" ngbDropdownItem
                         (click)="showEditImpersonationModal(Impersonation,EditImpersonationModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </a>
                      <a ngbDropdownItem class="drop-item px-3"
                         (click)="showDeleteImpersonationModal(Impersonation,deleteImpersonationModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </a>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr *ngIf="ImpersonationPagingResult.length == 0">
                <td colspan="5">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>

          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setImpersonationListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="ImpersonationPaging" [group]="ImpersonationForm" #ImpersonationPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>

  </div>
  <!-- Add Modal -->
  <ng-template #AddImpersonationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("ImpersonationRule")}}</h1>
      </div>

      <form [formGroup]="AddImpersonationForm" (ngSubmit)="addImpersonation()">

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="SourceParticipantType" (OnChange)="SourceParticipant($event)" [group]="AddImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-DropdownList [options]="SourcePermissionSetList" *ngIf="ShowSourcePermissionList" [group]="AddImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-AutocompleteTextBox [options]="SourceUserAutoComplete" *ngIf="ShowSourceUserAutoComplete" [group]="AddImpersonationForm">
            </BBSF-AutocompleteTextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="DestinationParticipantType" (OnChange)="DestinationParticipant($event)" [group]="AddImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-DropdownList [options]="DestinationPermissionSetList" *ngIf="ShowDestinationPermissionList" [group]="AddImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-AutocompleteTextBox [options]="DestinationUserAutoComplete" *ngIf="ShowDestinationUserAutoComplete" [group]="AddImpersonationForm">
            </BBSF-AutocompleteTextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="IsActive" [group]="AddImpersonationForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DateTimePicker [options]="ExpiresAt" [group]="AddImpersonationForm">

            </BBSF-DateTimePicker>
          </div>
        </div>
        <div class="text-center pt-7">
          <button CloseImpersonationModal id="CloseImpersonationModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>
  <!--Edit Modal-->
  <ng-template #EditImpersonationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("ImpersonationRule")}}</h1>
      </div>
      <form [formGroup]="EditImpersonationForm"  (ngSubmit)="editImpersonation()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditSourceParticipantType" (OnChange)="EditSourceParticipant($event)" [group]="EditImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditSourcePermissionSetList" *ngIf="EditShowSourcePermissionList" [group]="EditImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-AutocompleteTextBox [options]="EditSourceUserAutoComplete" *ngIf="EditShowSourceUserAutoComplete" [group]="EditImpersonationForm">
            </BBSF-AutocompleteTextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditDestinationParticipantType" (OnChange)="EditDestinationParticipant($event)" [group]="EditImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditDestinationPermissionSetList" *ngIf="EditShowDestinationPermissionList" [group]="EditImpersonationForm">
            </BBSF-DropdownList>
          </div>
          <div class="col-md-12">
            <BBSF-AutocompleteTextBox [options]="EditDestinationUserAutoComplete" *ngIf="EditShowDestinationUserAutoComplete" [group]="EditImpersonationForm">
            </BBSF-AutocompleteTextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditIsActive" [group]="EditImpersonationForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DateTimePicker [options]="EditExpiresAt" [group]="EditImpersonationForm">

            </BBSF-DateTimePicker>
          </div>
        </div>
        <div class="text-center pt-7">
          <button  #CloseEditImpersonationModal id="CloseEditImpersonationModal" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>
  <!--delete Modal-->
  <ng-template #deleteImpersonationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("ImpersonationRule")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteImpersonationModal id="CloseDeleteImpersonationModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteImpersonation()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>
